import * as React from 'react';
import { useInterviewController } from '../../../../hooks/controllers/interview-controller';
import { BoxTag } from './data-table-styled';
import { Tag } from './tag';

export const InterviewRuralResult = ({ props }) => {
  const { getStatusInterview } = useInterviewController();
  const [result, setResult] = React.useState('');

  React.useEffect(() => {
    setResult(getStatusInterview(props));
  }, [getStatusInterview, props]);

  const getStatusEmailResult = React.useCallback(
    (tagKey, icon) => {
      return (
        <BoxTag>
          <Tag tagKey={tagKey} label={result} icon={icon} />
        </BoxTag>
      );
    },
    [result],
  );

  const getDefaultInterview = React.useCallback(() => {
    return <Tag tagKey="default" label={result} />;
  }, [result]);

  const statusInterviewMap = {
    APTO: getStatusEmailResult('check', 'check'),
    NAO_APTO: getStatusEmailResult('nao_apto', 'ban'),
    CONCLUIDO: getStatusEmailResult('check', 'check'),
    AGUARDANDO_AVALIACAO: getStatusEmailResult('pending', 'clock'),
    // SEM_RESULTADO: getStatusEmailResult('default', 'close'),
  };
  return statusInterviewMap?.[props.statusInterview] ?? getDefaultInterview();
};
